import { setHeaders } from "API/axios";
import { successLogin } from "context/userSlice";

export default function setHeadersAndUser(dispatch, data) {
  setHeaders(data?.accessToken);
  dispatch(successLogin(data?.user));
}
